import {Radar} from '@crema/modules/thirdParty';

export default Radar;
